import React from 'react';
import { Box, Tooltip } from '@mui/material';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import { useNavigate } from 'react-router-dom';

function ContactButton() {
  const navigate = useNavigate();

  return (
    <Tooltip
      title={
        <span>
          <strong>We're Online!</strong>
          <br />
          How may I help you today?
        </span>
      }
      placement="left"
      arrow>
      <Box
        component="span"
        role="button"
        tabIndex={0}
        aria-label="Contact Us"
        onClick={() => navigate('/contact')}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate('/contact');
          }
        }}
        sx={{
          position: 'fixed',
          right: 24,
          bottom: 24,

          width: '58px',
          height: '58px',
          minWidth: '58px',
          minHeight: '58px',
          maxWidth: '58px',
          maxHeight: '58px',

          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          boxSizing: 'border-box',
          padding: 0,
          margin: 0,

          backgroundColor: '#cb6423',
          color: '#FFFFFF',

          cursor: 'pointer',
          userSelect: 'none',

          boxShadow: '0 4px 14px rgba(0, 0, 0, 0.22)',

          zIndex: (theme) => theme.zIndex.drawer + 1,

          transition: 'background-color 200ms ease, box-shadow 200ms ease',

          '&:hover': {
            backgroundColor: '#b75a20',
            boxShadow: '0 5px 16px rgba(0, 0, 0, 0.26)'
          },

          '&:focus-visible': {
            outline: '2px solid #cb6423',
            outlineOffset: '3px'
          },

          '& .MuiSvgIcon-root': {
            fontSize: 26
          }
        }}>
        <ChatOutlinedIcon />
      </Box>
    </Tooltip>
  );
}

export default ContactButton;
